angular.module('wbDashboard').controller('TestControllerAurea', ['$scope', '$window', '$uibModal', '$filter', '$timeout', 'User', 'Message', 'GoogleApi', 'NgTableParams', 'Track', function ($scope, $window, $uibModal, $filter, $timeout, User, Message, GoogleApi, NgTableParams, Track) {

    $scope.pageData = {
        sending: false,
        errorMsg: null
    };
    $scope.forms = {};

    $scope.$stateParams.page = 'mobile';

}]);
